module.exports = __webpack_public_path__ + "img/0-53.5fb60bc8.jpg";